import React from 'react'
import { Card } from 'primereact/card';
import { Col, Row, FormGroup, Input } from 'reactstrap'
import {InputMask} from 'primereact/inputmask';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import { Button } from 'primereact/button';
import Formatacao from '@/app/util/formatacao'
import { STRINGS } from '@/app/constants/componentStrings';

export default class Licitacao extends React.Component {

    visualizarDocumento = (event, docId) => {
        event.preventDefault();
        const url = `${process.env.REACT_APP_API_URL}/api/documents/licitacao/${docId}`
        window.open(url,'_blank','toolbar=yes')
    }

    visualizarDocTemplate = (rowData) => (
        <Button type="button" onClick={e => this.visualizarDocumento(e, rowData.id)}
                    icon="pi pi-download" 
                    className="p-button-primary"
                    style={{marginRight: '.5em'}}>
        </Button>
    )
        
    render(){

        const { numero, ano, modalidade, viproc, dataCertameFormatado, valorEstimado, valorArrematado } = this.props.value
        const { documentos } = this.props.value

        return (
            <Card title="Processo Licitatório">
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputNumero">Número</label>
                            <Input id="inputNumero" disabled={true} type="text" value={`${numero}/${ano}`} />
                        </FormGroup>
                    </Col>
    
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputModalidade">Modalidade</label>
                            <Input id="inputModalidade" disabled={true} type="text" value={ modalidade && modalidade.descricao} />
                        </FormGroup>
                    </Col>
    
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputProcesso">Processo</label>
                            <Input id="inputProcesso" 
                                       className="form-control" 
                                       autoClear
                                       mask="999999?9/9999"
                                       disabled={true} type="text" value={viproc} />
                        </FormGroup>
                    </Col>  
                   
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputModalidade">Data Certame</label>
                            <Input id="inputModalidade" disabled={true} type="text" value={dataCertameFormatado} />
                        </FormGroup>
                    </Col>
                </Row>
    
                <Row>

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputEstimado">Valor Estimado</label>
                            <Input id="inputEstimado" disabled={true} type="text" value={Formatacao.currency(valorEstimado)} />
                        </FormGroup>
                    </Col>
    
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputArrematado">Valor Arrematado</label>
                            <Input id="inputArrematado" disabled={true} type="text" value={Formatacao.currency(valorArrematado)} />
                        </FormGroup>
                    </Col>
                </Row>

                <br />
                
                <Row>
                    <Col md={12}>               
                        <DataTable value={documentos} emptyMessage={STRINGS.emptyMessage} header="Documentação">
                            <Column field="descricaoTipoDocumento" header="Documento" />
                            <Column field="nomeArquivo" header="Arquivo" />
                            <Column  body={this.visualizarDocTemplate} className="coluna-acao"/>
                        </DataTable>
                    </Col>                    
                </Row>     
                

            </Card>
        )
    }
} 